// @ts-nocheck
export const truncate = `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `
